import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { Col, Row } from 'reactstrap';
import { InputNormal, SelectNormal } from '../Plugins/SpecialForm';
import { BANCOS_VENEZUELA, DNI, PM_VENEZUELA, PM_PREFIX } from '../../constants/general';
import Notification from '../../handlers/Notification';

class PayoutAccounts extends Component {
	constructor (props) {
		super(props);
        let banks = BANCOS_VENEZUELA.map((bank) => ({ value: bank, name: bank}));
		this.state = {
            banks: banks,
            bankTransferForms: {},
            pmForms: {},
            paymentType: "bankTransferForms"
		}
	}

    componentDidMount(){
        this.validateForm();
    }

    onBankFormChange(event){
        let { name, value } = event;

        name === 'account' || name === 'document' ? value = value.replace(/[^0-9]/g, '') : null

        this.setState(prevState => ({
            bankTransferForms: {
                ...prevState.bankTransferForms,
                [name]: value || ""
            }
        }), () => this.validateForm());
    }

    onPmFormChange(event){
        let { name, value } = event;

        name === 'phone' || name === 'document' ? value = value.replace(/[^0-9]/g, '') : null

        this.setState(prevState => ({
            pmForms: {
                ...prevState.pmForms,
                [name]: value || ""
            }
        }), () => this.validateForm());
    }

    validateEmail(email) {
        if(email){
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        } else {
            return true;
        }
    }

    validateForm() {
        const { bankTransferForms, pmForms, paymentType } = this.state;

        let isValid = true;
        if(paymentType === "bankTransferForms") {
            isValid &= !!bankTransferForms.bank_name && !!bankTransferForms.document_prefix && !!bankTransferForms.document &&
                !!bankTransferForms.account && !!bankTransferForms.name &&
                bankTransferForms.document.length >= 6 &&
                bankTransferForms.account.length >= 20 &&
                this.validateEmail(bankTransferForms.email);
                this.props.appendPayoutAccount(bankTransferForms)
        }
        if(paymentType === "pmForms"){
            isValid &= !!pmForms.bank_code && !!pmForms.document_prefix && !!pmForms.document &&
                !!pmForms.phone_prefix && !!pmForms.phone &&
                pmForms.document.length >= 6 &&
                pmForms.phone.length >= 7;
                this.props.appendPayoutAccount(pmForms)
        }

        this.props.validatePaymentForm(isValid === 0 ? false : true);

    }

    handleSavePaymentType(){
        const { bankTransferForms, pmForms } = this.state;

        let newBankTransferData = []
        let newPmData = []
		let data = []

		if(bankTransferForms.bank_name){
			newBankTransferData = [{
                bank_name: bankTransferForms.bank_name,
                document: `${bankTransferForms.document_prefix}${bankTransferForms.document}`,
                account: bankTransferForms.account,
                name: bankTransferForms.name,
                email: bankTransferForms.email || '',
                type: "national_bank_account"
            }]
			data = [...data, ...newBankTransferData];
		}

		if(pmForms.bank_code){
			newPmData = [{
				bank_code: pmForms.bank_code,
				document: `${pmForms.document_prefix}${pmForms.document}`,
				phone: `${pmForms.phone_prefix}${pmForms.phone}`,
				type: "mobile_payment"
            }]
			data = [...data, ...newPmData]
		}
    }

    handleClearPaymentData(type) {
        this.setState({
            [type]: {}
        },() => this.validateForm());
    }

    closeModal = () => {
    	if(this.props && this.props.reference){
    		this.props.reference()
    	}
    }

	render () {
        const { json_lang } = this.props
        const { banks, bankTransferForms, pmForms, paymentType } = this.state

        return <Fragment>
                <select
					className="form-control w-100 mb-5"
					style={{ height: "50px" }}
					onChange={(e) => this.setState({
                        paymentType: e.target.value,
                        [e.target.value]: {}
                    })}
					value={paymentType}
				>
					<option value="bankTransferForms">Transferencia bancaria</option>
					<option value="pmForms">Pago móvil</option>
				</select>
                {
                    paymentType === "bankTransferForms" && (
                        <Fragment>
                            <Row>
                                <Col xs="24" sm="12" md="12" lg="12">
                                    <SelectNormal
                                        name={"bank_name"}
                                        label_text ={"Banco"}
                                        text_init={json_lang.common.select_placeholder}
                                        options={banks}
                                        val={bankTransferForms.bank_name || ''}
                                        onchange={(e) => this.onBankFormChange(e.target)}
                                        className={'h-25'}
                                        unrequired
                                        />
                                </Col>
                                <Col xs="24" sm="24" md="12" lg="12">
                                    <div style={{ display: 'flex' }}>
                                        <SelectNormal
                                            name={"document_prefix"}
                                            label_text ={"Tipo"}
                                            text_init={json_lang.common.select_placeholder}
                                            options={DNI}
                                            val={bankTransferForms.document_prefix || ''}
                                            onchange={(e) => this.onBankFormChange(e.target)}
                                            className={'w-25 h-25'}
                                            unrequired
                                            />
                                        <InputNormal
                                            name = {"document"}
                                            labelName = {"Cédula"}
                                            maxLength = {9}
                                            placeholder = "12345678"
                                            value = {bankTransferForms.document || ''}
                                            onChange = { (e) => this.onBankFormChange(e.target) }
                                            className = {'w-75 ml-2'}
                                            unrequired
                                            />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" sm="12" md="6" lg="6">
                                    <InputNormal
                                        name = {"account"}
                                        labelName = {"Número de cuenta"}
                                        placeholder="01021234567891011121"
                                        maxLength={20}
                                        value={bankTransferForms.account || ''}
                                        onChange = { (e) => this.onBankFormChange(e.target) }
                                        unrequired
                                        />
                                </Col>
                                <Col xs="12" sm="12" md="6" lg="6">
                                    <InputNormal
                                        name = {"name"}
                                        labelName = {"Nombre del beneficiario"}
                                        placeholder="Pepito Pérez"
                                        value={bankTransferForms.name || ''}
                                        onChange = { (e) => this.onBankFormChange(e.target) }
                                        unrequired
                                        />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="24" sm="24" md="12" lg="12">
                                    <InputNormal
                                        name = {"email"}
                                        labelName = {"Correo electrónico"}
                                        placeholder="nombre@email.com"
                                        value={bankTransferForms.email || ''}
                                        onChange = { (e) => this.onBankFormChange(e.target) }
                                        unrequired />
                                </Col>
                            </Row>
                        </Fragment>
                    )
                }
                {
                    paymentType === "pmForms" && (
                        <Fragment>
                            <Row>
                                <Col xs="24" sm="24" md="12" lg="12">
                                    <SelectNormal
                                        name={"bank_code"}
                                        label_text ={"Banco"}
                                        text_init={json_lang.common.select_placeholder}
                                        options={PM_VENEZUELA}
                                        val={pmForms.bank_code || ''}
                                        onchange={(e) => this.onPmFormChange(e.target)}
                                        className={'h-25'}
                                        unrequired
                                        />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="24" sm="24" md="12" lg="12">
                                    <div style={{ display: 'flex' }}>
                                        <SelectNormal
                                            name={"document_prefix"}
                                            label_text ={"Tipo"}
                                            text_init={json_lang.common.select_placeholder}
                                            options={DNI}
                                            val={pmForms.document_prefix || ''}
                                            onchange={(e) => this.onPmFormChange(e.target)}
                                            className={'w-25 h-25'}
                                            unrequired
                                            />
                                        <InputNormal
                                            name = {"document"}
                                            labelName ={"Cédula"}
                                            maxLength = {9}
                                            placeholder="12345678"
                                            value={pmForms.document || ''}
                                            onChange = { (e) => this.onPmFormChange(e.target) }
                                            className ={'w-75 ml-2'}
                                            unrequired
                                            />
                                    </div>
                                </Col>
                                <Col xs="24" sm="24" md="12" lg="12">
                                    <div style={{ display: 'flex' }}>
                                        <SelectNormal
                                            name={"phone_prefix"}
                                            label_text ={"Operadora"}
                                            text_init={json_lang.common.select_placeholder}
                                            options={PM_PREFIX}
                                            val={pmForms.phone_prefix || ''}
                                            onchange={(e) => this.onPmFormChange(e.target)}
                                            className={'w-25 h-25'}
                                            unrequired
                                            />
                                        <InputNormal
                                            name = {"phone"}
                                            labelName ={"Teléfono"}
                                            placeholder="1234567"
                                            maxLength={7}
                                            value={pmForms.phone || ''}
                                            onChange = { (e) => this.onPmFormChange(e.target) }
                                            className ={'w-75 ml-2'}
                                            unrequired
                                            />
                                    </div>
                                </Col>
                            </Row>
                        </Fragment>
                    )
                }
            </Fragment>
	}
}

const mapStateToProps = (state) => {
	return {
		json_lang: state.json_lang,
        branch: state.branch
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PayoutAccounts);



// WEBPACK FOOTER //
// ./src/views/Register/PayoutAccounts.jsx